import { request as __request } from '../request/request';
import { OpenAPI } from '../request/open-api';
import { CancelablePromise } from '../request/cancelable-promise';
import { ECGStudyResponseDto } from 'types/types/dto/ecg-study-response-dto';

export const getCaregiverEcgs = (
  caregiverId: String,
  limit: number,
  skip: number,
): CancelablePromise<ECGStudyResponseDto> => {
  return __request(OpenAPI, {
    method: 'GET',
    url: `/caregivers/ecgs/${caregiverId}`,
    path: {
      caregiverId: String,
    },
    query: {
      limit: limit,
      skip: skip,
    },
    errors: {
      400: `Bad Request`,
      401: `Unauthorized`,
      403: `Forbidden`,
      404: `Not Found`,
      422: `Unprocessable Entity`,
    },
  });
};
